import prod from './prod';

// also including alias to support multiple naming across the application
export { prod, prod as production };
